import React from 'react';
import PropTypes from 'prop-types';
import '../../assets/css/elements/button.css';

const Button = ({
    text,
    onClick,
    icon,
    iconPosition = 'right',
    type = 'button',
    variant = 'primary',
    disabled = false,
    className = '',
    fullWidth = false,
    loading = false,
}) => {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled || loading}
            className={`btn btn-${variant} ${fullWidth ? 'full-width' : ''} ${loading ? 'btn-loading' : ''} ${className}`}
        >
            {loading ? (
                <span className="btn-spinner"></span>
            ) : (
                <>
                    {icon && iconPosition === 'left' && <span className="btn-icon left">{icon}</span>}
                    {text}
                    {icon && iconPosition === 'right' && <span className="btn-icon right">{icon}</span>}
                </>
            )}
        </button>
    );
};

Button.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    icon: PropTypes.element,
    iconPosition: PropTypes.oneOf(['left', 'right']),
    type: PropTypes.oneOf(['button', 'submit', 'reset']),
    variant: PropTypes.oneOf(['primary', 'secondary', 'outline']),
    disabled: PropTypes.bool,
    className: PropTypes.string,
    fullWidth: PropTypes.bool,
    loading: PropTypes.bool,
};

export default Button;